import _ from 'lodash';
import { connect } from 'react-redux';
import {
	add,
	//get,
	publicGet,
	submitLoadingNumbers,
	carrierConfirm,
	supplierConfirm,
	getNextEmail,
	activate
} from '../../modules/logistics/bulkDeliveryBatch';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let bulkDeliveryBatch;
	let bulkDeliveryBatchId;

	if (ownProps.bulkDeliveryBatch) {
		bulkDeliveryBatch = ownProps.bulkDeliveryBatch;
	} else {
		bulkDeliveryBatchId = (ownProps.bulkDeliveryBatchId)
			? ownProps.bulkDeliveryBatchId
			: _.get(ownProps, ['match', 'params', 'bulkDeliveryBatchId']);
		bulkDeliveryBatch = _.get(state.maps, ['bulkDeliveryBatch', bulkDeliveryBatchId]);
	}

	return {
		bulkDeliveryBatch,
		bulkDeliveryMap : state.maps.bulkDelivery,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	//getBulkDeliveryBatch : get,
	addBulkDeliveryBatch : add,
	getNextEmailForBulkDeliveryBatch : getNextEmail,
	activateBulkDeliveryBatch : activate,
	publicGetBulkDeliveryBatch : publicGet,
	submitSupplierLoadingNumbersForBatch : submitLoadingNumbers,
	carrierConfirmBulkDeliveryBatch : carrierConfirm,
	supplierConfirmBulkDeliveryBatch : supplierConfirm,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
